module.exports = __webpack_public_path__ + "static/bottom-2-8e08d9f84ab89901425faf9685768247.jpg";